import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import api from "../../../Utils/api";

const NewUser = () => {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const passwordRef = useRef(null);

  const [user, setUser] = useState({
    lastname: "",
    firstname: "",
    username: "",
    contact: "",
    password: "",
    roles: "",
    isActif: "",
  });

  useEffect(() => {
    document.title = "DashBoard | Nouvel Utilisateur";
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    console.log(name, value);
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckPassword = (e) => {
    const { value } = e.target;
    const password = user.password;

    if (password !== value) {
      setUser({ ...user, password: "" });
      passwordRef.current.value = "";
      e.target.value = "";
      toast.error("Les mots de passe ne sont pas identiques.");
    }
  };

  const handleCheckContact = (e) => {
    const { value } = e.target;
    if (value.trim().length <= 0) return;
    // const regex = /^\+\d{1,2}\s?\d{10}$/;
    // console.log(value.length);
    if (value.length < 10) {
      setUser({ ...user, contact: "" });
      e.target.value = "";
      toast.warning("Le contact doit contenir au moins 10 chiffres.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await api.post("users", user);

      if (response.data.user) {
        toast.success("Utilisateur ajouté avec succès.");
        navigate("/utilisateurs");
      } else {
        toast.error("Vérifier vos données avant la soumission.");
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
      if (error.response.status === 404) {
        toast.error("Cet E-mail est déjà utilisé.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <PageHeader page="Nouvel Utilisateur" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header"></div>
            <div className="card-body">
              <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label htmlFor="lastname" className="col-sm-2 col-form-label">
                    Nom
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="lastname"
                      name="lastname"
                      onChange={handleChange}
                      value={user.lastname}
                      placeholder="Nom"
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="firstname"
                    className="col-sm-2 col-form-label"
                  >
                    Prénom
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="firstname"
                      name="firstname"
                      onChange={handleChange}
                      value={user.firstname}
                      placeholder="Prénom"
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="username" className="col-sm-2 col-form-label">
                    Nom d'utilisateur
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      name="username"
                      onChange={handleChange}
                      value={user.username}
                      placeholder="Nom d'utilisateur"
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="inputContact"
                    className="col-sm-2 col-form-label"
                  >
                    Contact
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      id="inputContact"
                      name="contact"
                      onChange={handleChange}
                      value={user.contact}
                      placeholder="Contact"
                      onBlur={handleCheckContact}
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="password" className="col-sm-2 col-form-label">
                    Mot de passe
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      onChange={handleChange}
                      value={user.password}
                      placeholder="Mot de passe"
                      ref={passwordRef}
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="repassword"
                    className="col-sm-2 col-form-label"
                  >
                    Confirmer le mot de passe
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="password"
                      className="form-control"
                      id="repassword"
                      name="repassword"
                      onBlur={handleCheckPassword}
                      placeholder="Confirmer le mot de passe"
                      required
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="roles" className="col-sm-2 col-form-label">
                    Role
                  </label>
                  <div className="col-sm-10">
                    <select
                      className="custom-select form-control-border"
                      id="roles"
                      name="roles"
                      onChange={handleChange}
                      value={user.roles}
                      required
                    >
                      <option value="">Choisir un role</option>
                      <option value="ROLE_MOD">Modérateur</option>
                      <option value="ROLE_ADMIN">Administrateur</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="isActif" className="col-sm-2 col-form-label">
                    Status
                  </label>
                  <div className="col-sm-10">
                    <select
                      className="custom-select form-control-border"
                      id="isActif"
                      name="isActif"
                      onChange={handleChange}
                      value={user.isActif}
                      required
                    >
                      <option value="">Choisir un status</option>
                      <option value="true">Activé</option>
                      <option value="false">Désactivé</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="offset-sm-2 col-sm-10">
                    <button
                      type="submit"
                      className="btn btn-info"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spin size="sm" /> : "Ajouter"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default NewUser;
